import { scienceBlue, solidBlack, blueGray54 } from '../../theme/colors';

export default {
  dialogLabelStyle: {
    color: scienceBlue
  },
  dialogActionsContainerStyle: {
    borderTop: '1px solid rgba(151, 151, 151, .29)'
  },
  dialogContentStyle: {
    width: '90%',
    maxWidth: '480px',
    textAlign: 'center'
  },
  dialogTitleStyle: {
    fontWeight: '600',
    color: solidBlack
  },
  paperStyle: {
    margin: '0 auto',
    maxWidth: '500px'
  },
  flatButtonStyle: {
    height: '68px'
  },
  prevLabelStyle: {
    color: blueGray54,
    fontWeight: 600,
    padding: '0 0 0 24px'
  },
  nextLabelStyle: {
    fontWeight: 600,
    padding: '0 24px 0 0'
  }
};
